type OneIdIconType = {
  size?: number | undefined
}

function OneIdIcon({ size }: OneIdIconType) {
  return (
    <img
      src={`/oneid.svg`}
      width={size || '20px'}
      height={size || '20px'}
      style={{marginRight: '5px'}}
      alt=""
    />
  )
}

export default OneIdIcon